// extracted by mini-css-extract-plugin
export var wordContainer = "_np-0";